if (document.getElementById('page-stage')) {
  const header = document.querySelector('.header--stage')
  const label = document.querySelector('.stLabel')

  const adjustMenu = () => {
    const { scrollTop } = document.documentElement

    const labelBottom = label.getBoundingClientRect().top + label.clientHeight + scrollTop
    if (scrollTop < labelBottom) {
      header.classList.add('is_hide')
    } else {
      header.classList.remove('is_hide')
    }
  }

  document.addEventListener('scroll', adjustMenu)
  document.addEventListener('resize', adjustMenu)
  adjustMenu()
}
